import { Typography } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"

import { joinNames } from "../../helpers/join-names.ts"
import { waitingOn } from "../../helpers/manager-views.ts"
import {
  WIZARD_STEPS,
  resumeStep,
  stepNumber
} from "../../helpers/wizard-steps.ts"
import type { TrackedEnvelope } from "../../types/tracking.types.ts"

const { Text } = Typography

/** The line under a status: what happens next, read off the request itself. */
export function NextStep({
  envelope,
  canCountersign
}: {
  envelope: TrackedEnvelope
  canCountersign: boolean
}) {
  const { t, i18n } = useTranslation()
  if (envelope.status === "draft") {
    return (
      <Text type={"secondary"} className={"text-xs"}>
        {t("esign.manager.draftStep", {
          number: stepNumber(resumeStep(envelope.draft_step)),
          count: WIZARD_STEPS.length
        })}
      </Text>
    )
  }
  if (envelope.status === "signed" || envelope.status === "completed") {
    return (
      <Text type={"secondary"} className={"text-xs"}>
        {t("esign.manager.nextEveryoneSigned")}
      </Text>
    )
  }
  if (envelope.stage === "awaiting_countersignature" && canCountersign) {
    return (
      <Text type={"secondary"} className={"text-xs"}>
        {t("esign.manager.nextYourTurn")}
      </Text>
    )
  }
  const names = waitingOn(envelope).map((recipient) => recipient.name)
  if (!envelope.stage || !names.length) return null
  return (
    <Text type={"secondary"} className={"text-xs"}>
      {t("esign.manager.nextWaitingOn", {
        names: joinNames(names, i18n.language)
      })}
    </Text>
  )
}
